// extracted by mini-css-extract-plugin
export default {"container":"container___J6KcG","spin":"spin___pUJtu","description":"description___VgDoi"};